import GrabIDRedirect from './grab-id-redirect';

export default GrabIDRedirect;
